import React from "react";
import PayoutFlowSteps from "./PayoutFlowSteps";

const beneficiaryFlowSteps = [
  "Beneficiary Details",
  "Review",
  "Google Authenticator Verification",
  "Confirm",
];

function PayoutBeneficiaryFlowSteps({ activeStep }: { activeStep: number }) {
  return <PayoutFlowSteps steps={beneficiaryFlowSteps} activeStep={activeStep} />;
}

export default PayoutBeneficiaryFlowSteps;
